export const GridFeatureModeConstant = {
  client: 'client',
  server: 'server'
};